"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _FileSummaryQueryResult = _interopRequireDefault(require("../model/FileSummaryQueryResult"));
var _QuoteResponse = _interopRequireDefault(require("../model/QuoteResponse"));
var _Rfq = _interopRequireDefault(require("../model/Rfq"));
var _RfqSummaryQueryResult = _interopRequireDefault(require("../model/RfqSummaryQueryResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Rfqs service.
* @module api/RfqsApi
* @version 0.0.1
*/
var RfqsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new RfqsApi. 
  * @alias module:api/RfqsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function RfqsApi(apiClient) {
    _classCallCheck(this, RfqsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the getRfqExportById operation.
   * @callback module:api/RfqsApi~getRfqExportByIdCallback
   * @param {String} error Error message, if any.
   * @param {String} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * @param {Number} rfqId 
   * @param {module:api/RfqsApi~getRfqExportByIdCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link String}
   */
  return _createClass(RfqsApi, [{
    key: "getRfqExportById",
    value: function getRfqExportById(rfqId, callback) {
      var postBody = null;
      // verify the required parameter 'rfqId' is set
      if (rfqId === undefined || rfqId === null) {
        throw new Error("Missing the required parameter 'rfqId' when calling getRfqExportById");
      }
      var pathParams = {
        'rfq_id': rfqId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['*/*'];
      var returnType = 'String';
      return this.apiClient.callApi('/rfqs/{rfq_id}/export', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the rfqsCompanyCompanyIdFilesFileIdGet operation.
     * @callback module:api/RfqsApi~rfqsCompanyCompanyIdFilesFileIdGetCallback
     * @param {String} error Error message, if any.
     * @param {String} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} companyId 
     * @param {Number} fileId 
     * @param {module:api/RfqsApi~rfqsCompanyCompanyIdFilesFileIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link String}
     */
  }, {
    key: "rfqsCompanyCompanyIdFilesFileIdGet",
    value: function rfqsCompanyCompanyIdFilesFileIdGet(companyId, fileId, callback) {
      var postBody = null;
      // verify the required parameter 'companyId' is set
      if (companyId === undefined || companyId === null) {
        throw new Error("Missing the required parameter 'companyId' when calling rfqsCompanyCompanyIdFilesFileIdGet");
      }
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling rfqsCompanyCompanyIdFilesFileIdGet");
      }
      var pathParams = {
        'company_id': companyId,
        'file_id': fileId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['*/*'];
      var returnType = 'String';
      return this.apiClient.callApi('/rfqs/company/{company_id}/files/{file_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the rfqsCompanyCompanyIdFilesGet operation.
     * @callback module:api/RfqsApi~rfqsCompanyCompanyIdFilesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileSummaryQueryResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} companyId 
     * @param {Number} limit 
     * @param {module:api/RfqsApi~rfqsCompanyCompanyIdFilesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileSummaryQueryResult}
     */
  }, {
    key: "rfqsCompanyCompanyIdFilesGet",
    value: function rfqsCompanyCompanyIdFilesGet(companyId, limit, callback) {
      var postBody = null;
      // verify the required parameter 'companyId' is set
      if (companyId === undefined || companyId === null) {
        throw new Error("Missing the required parameter 'companyId' when calling rfqsCompanyCompanyIdFilesGet");
      }
      // verify the required parameter 'limit' is set
      if (limit === undefined || limit === null) {
        throw new Error("Missing the required parameter 'limit' when calling rfqsCompanyCompanyIdFilesGet");
      }
      var pathParams = {
        'company_id': companyId
      };
      var queryParams = {
        'limit': limit
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json'];
      var returnType = _FileSummaryQueryResult["default"];
      return this.apiClient.callApi('/rfqs/company/{company_id}/files', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the rfqsGet operation.
     * @callback module:api/RfqsApi~rfqsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RfqSummaryQueryResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset 
     * @param {Number} opts.limit 
     * @param {String} opts.search 
     * @param {Boolean} opts.opportunityIsActiveOnly 
     * @param {String} opts.contact 
     * @param {String} opts.companyId 
     * @param {module:api/RfqsApi~rfqsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RfqSummaryQueryResult}
     */
  }, {
    key: "rfqsGet",
    value: function rfqsGet(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'offset': opts['offset'],
        'limit': opts['limit'],
        'search': opts['search'],
        'opportunity_is_active_only': opts['opportunityIsActiveOnly'],
        'company_id': opts['companyId'],
        'is_not_quoted': opts['isNotQuoted'],
        'filter_prjs': opts['filterPRJs']
      };
      var headerParams = {
        'contact': opts['contact']
      };
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _RfqSummaryQueryResult["default"];
      return this.apiClient.callApi('/rfqs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the rfqsIdGet operation.
     * @callback module:api/RfqsApi~rfqsIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Rfq} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} id 
     * @param {module:api/RfqsApi~rfqsIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Rfq}
     */
  }, {
    key: "rfqsIdGet",
    value: function rfqsIdGet(id, callback) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling rfqsIdGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Rfq["default"];
      return this.apiClient.callApi('/rfqs/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the rfqsIdPost operation.
     * @callback module:api/RfqsApi~rfqsIdPostCallback
     * @param {String} error Error message, if any.
     * @param {Number} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/QuoteResponse} opts.quoteResponse 
     * @param {module:api/RfqsApi~rfqsIdPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Number}
     */
  }, {
    key: "rfqsIdPost",
    value: function rfqsIdPost(id, opts, callback) {
      opts = opts || {};
      var postBody = opts['quoteResponse'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling rfqsIdPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = 'Number';
      return this.apiClient.callApi('/rfqs/{id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
}();